document.addEventListener('DOMContentLoaded', async () => {
    const root = document.querySelector('#official-carousel');

    if (!root) {
        return;
    }

    try {
        const response = await fetch('/api/official-carousel-banners');

        if (!response.ok) {
            throw new Error('無法讀取官方輪播 API。');
        }

        const payload = await response.json();
        const items = payload.data || [];
        const carouselInner = root.querySelector('.carousel-inner');

        if (items.length === 0 || !window.bootstrap || !window.bootstrap.Carousel) {
            return;
        }

        items.forEach((item, index) => {
            const slide = document.createElement('div');
            slide.className = `carousel-item${index === 0 ? ' active' : ''}`;

            const link = document.createElement('a');
            link.href = item.link_url;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';

            const image = document.createElement('img');
            image.src = item.image_url;
            image.alt = '';
            image.className = 'd-block w-100 official-carousel-image';

            link.appendChild(image);
            slide.appendChild(link);
            carouselInner.appendChild(slide);
        });

        root.removeAttribute('hidden');

        const carousel = new window.bootstrap.Carousel(root, {
            interval: 5000,
            ride: 'carousel',
            wrap: true,
            pause: false,
            touch: true,
        });

        root.addEventListener('slid.bs.carousel', () => carousel.cycle());

        document.addEventListener('click', (event) => {
            if (!root.contains(event.target)) {
                carousel.cycle();
            }
        });
    } catch (error) {
        console.error('官方輪播載入失敗：', error);
    }
});
